export default "__VITE_ASSET__CbTlDG32__"